import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { useNavigate } from 'react-router-dom';
export function FinalCTA() {
  const navigate = useNavigate();
  return <section className="py-32 bg-primary border-t border-gray-200/50" data-id="element-41">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-43">
          <h2 className="text-4xl md:text-6xl font-bold text-text-primary mb-6 font-serif" data-id="element-44">
            Stop Guessing.{' '}
            <span className="text-accent italic" data-id="element-45">Start Fitting.</span>
          </h2>
          <p className="text-xl text-text-muted mb-10 max-w-xl mx-auto" data-id="element-46">
            Join thousands of women who have stopped settling for "good enough"
            and found clothes that actually work for their height.
          </p>

          <div className="flex flex-col items-center space-y-4" data-id="element-47">
            <Button size="lg" className="w-full sm:w-auto min-w-[240px] text-lg shadow-xl hover:shadow-2xl" onClick={() => navigate('/try-it')} data-id="element-48">
              Get My Perfect Fit
            </Button>
            <p className="text-sm text-text-muted font-medium tracking-wide" data-id="element-49">
              Free • Cancel anytime • No spam
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}